import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';

function KTDropdownFilter({
    label = '',
    filterKey = '',
    options = [],
    selectedValue = '',
    selectedOption = null,
    isInDropdown = false,
    additionalClassName = '',
    handleChange = () => { },
    searchable = false,
    disabled = false,
}) {
    const getDisplayName = () => {
        const option = selectedOption ?? options.find((item) => item.value === selectedValue);
        if (option) return option.name;
        return 'Tất cả';
    };

    return (
        <div className={`${isInDropdown ? 'col-6' : 'flex-grow-1'} py-2 ${additionalClassName}`}>
            <label
                htmlFor={filterKey}
                className="mb-0 mr-2 font-weight-boldest"
                style={{ color: AppColors.gray[800] }}
            >
                {label}
            </label>
            <KTBSDropdown
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                            ${disabled ? 'disabled' : ''}`}
                        type="button"
                    >
                        <span
                            style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                minWidth: 0,
                            }}
                        >
                            {getDisplayName()}
                        </span>
                    </button>
                }
                selectedValue={selectedValue}
                dropdownMenuItems={options}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={handleChange}
                isDropdownForm={true}
                searchable={searchable}
                searchFormClassName="mx-3 my-1 search-form-border"
                disabled={disabled}
            />
        </div>
    );
}

export default KTDropdownFilter;